/**
 * UsernameIcon — a simple "character" silhouette (head + shoulders) for the
 * "Sign in with Username" button. Uses currentColor so it follows the button text.
 *
 * SYNC: SYSTEM_DESCRIPTION.md §1 "Authentication & Authorization"
 */
import React, { SVGProps } from "react";

export const UsernameIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      {/* head */}
      <circle cx="9" cy="5.4" r="3.3" fill="currentColor" />
      {/* shoulders / body */}
      <path
        d="M9 10.4c-3.7 0-6.7 2.5-6.7 5.6 0 .3.3.6.6.6h12.2c.3 0 .6-.3.6-.6 0-3.1-3-5.6-6.7-5.6z"
        fill="currentColor"
      />
    </svg>
  );
};
